<template>
  <div class="crm-login">
    <el-card class="crm-login-card" shadow="always">
      <div class="crm-brand">法多邦</div>
      <h1>电销管理系统</h1>
      <p>使用现有员工账号登录</p>
      <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent="submit">
        <el-form-item prop="username"><el-input v-model.trim="form.username" placeholder="员工账号" autocomplete="username" @keyup.enter.native="submit" /></el-form-item>
        <el-form-item prop="password"><el-input v-model="form.password" type="password" placeholder="密码" autocomplete="current-password" @keyup.enter.native="submit" /></el-form-item>
        <el-button type="primary" :loading="loading" class="crm-login-button" @click="submit">登录</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { postKeyValueRequest } from "../utils/api";
import { hasPermission } from "../utils/permission";
import { crmPages } from "./pages";

export default {
  name: "CrmLogin",
  data: () => ({
    loading: false,
    form: { username: "", password: "" },
    rules: {
      username: [{ required: true, message: "请输入员工账号", trigger: "blur" }],
      password: [{ required: true, message: "请输入密码", trigger: "blur" }],
    },
  }),
  methods: {
    clearSession() {
      ["token", "spbs", "title", "quanxian", "userInfo"].forEach((key) => sessionStorage.removeItem(key));
      this.$store.commit("INIT_TOKEN", "");
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid || this.loading) return;
        this.loading = true;
        try {
          const response = await postKeyValueRequest("/Login/login", this.form);
          if (response.code !== 200 || !response.data || !response.data.token) {
            this.$message.error(response.msg || "登录失败");
            return;
          }
          const data = response.data;
          this.$store.commit("INIT_TOKEN", data.token);
          this.$store.commit("INIT_SPBS", data.spbs || "");
          this.$store.commit("INIT_TITLE", data.title || "员工");
          this.$store.commit("INIT_QUANXIAN", data.quanxian || []);
          sessionStorage.setItem("userInfo", JSON.stringify({
            id: data.spbs, account: this.form.username, title: data.title,
            quanxian: data.quanxian, permission_codes: data.permission_codes || [],
          }));
          const landingPage = crmPages.find((page) => hasPermission(page.permission));
          if (!landingPage || !hasPermission("crm.menu")) {
            this.clearSession();
            this.$message.error("当前账号没有 CRM 使用权限");
            return;
          }
          const requested = String(this.$route.query.redirect || "");
          const allowed = crmPages.some((page) => page.path === requested && hasPermission(page.permission));
          this.$router.replace(allowed ? requested : landingPage.path);
        } catch (error) {
          this.$message.error("登录失败，请稍后重试");
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.crm-login { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; box-sizing: border-box; background: linear-gradient(145deg, #e8f1ff, #f6f8fc 55%, #dceaff); }
.crm-login-card { width: 100%; max-width: 400px; border: 0; border-radius: 16px; }
.crm-brand { color: #2677e9; font-weight: 700; letter-spacing: 2px; }
h1 { margin: 12px 0 8px; color: #1a2b47; font-size: 27px; }
p { margin: 0 0 26px; color: #718096; }
.crm-login-button { width: 100%; }
</style>
